import { MapPin } from '@liveauctioneers/hammer-ui-core/icons';
import { BodySecondary } from '@liveauctioneers/hammer-ui-core/text';

import { useAppSelector } from '@/redux/hooks';
import { getCatalogShortAddress } from '@/redux/modules/catalog/catalogs/catalog.selectors';

type Props = {
    catalogId: number;
};

export const HomepageAuctionCardLocation = ({ catalogId }: Props) => {
    const location = useAppSelector((state) => getCatalogShortAddress(state, catalogId));

    if (!location) {
        return null;
    }

    return (
        <BodySecondary className="flex items-baseline gap-x-2xs text-xs text-text-secondary">
            <span className="inline-flex shrink-0 translate-y-[2px] leading-none">
                <MapPin size="xs" />
            </span>
            <span className="truncate">{location}</span>
        </BodySecondary>
    );
};
